import { useParams } from "react-router-dom";
import InscricaoDescontoForm, { IInscricaoDescontoFormProps } from "./InscricaoDescontoForm";
import { useInscricaoDescontoBuscar } from "@/Services/Domain/Viagem/Inscricao/InscricaoDescontoService";
import TelaCarregamento from "@/Components/Base/Carregamento/TelaCarregamento";

export interface IInscricaoDescontoEditarScreenProps extends IInscricaoDescontoFormProps {
    codigo?:number;
}

export default function InscricaoDescontoEditarScreen({
    codigo : codigoParam,
    ...rest
}:IInscricaoDescontoEditarScreenProps) {
    const { codigo : codigoRota } = useParams();
    const codigo = isNaN(Number.parseInt(codigoRota ?? "")) ? codigoParam : Number.parseInt(codigoRota ?? "");

    const {
        data,
        isLoading
    } = useInscricaoDescontoBuscar({
        codigo : codigo ?? 0,
        enabled : !isNaN(codigo as number) && (codigo as number) > 0 //codigo !== undefined && codigo !== null && 
    });
    
    return <TelaCarregamento ativo={isLoading}>
        <InscricaoDescontoForm 
            {...rest}
            codigo={codigo}
            initialValues={{
                inscricaoDesconto : data ?? undefined
            }}
        />
    </TelaCarregamento>
}